<template>
    <div class="results-container">
        <div class="heading">
            <p class="title">Search Artists</p>
            <p class="subtitle">Select all the artists you want to apply to your event.</p>
        </div>
        <div class="results">
            <div v-if="artists.length">
                <Artist
                    v-for="(artist, index) in artists"
                    :key="index"
                    :artist="artist"
                    :cta="'Invite'"
                    :clear="clearSelection"
                    :max-width="'256px'"
                    :selectable="true"
                    :redirect="false"
                    @book-artist="bookArtist(artist)"
                />
            </div>
            <div v-else class="subtitle">
                Your search got no hits. Try removing some of the filters.
            </div>
        </div>
    </div>
</template>
<script>
    import Artist from '@/components/search-result-artist/Artist.vue'
    export default {
        name: 'Results',
        components: {
            Artist
        },
        props: {
            artists: {
                type: Array,
                required: true
            },
            userData: {
                type: Object,
                required: true
            },
            clearSelection: {
                type: Boolean,
                required: false,
                default: false
            },
            toggleArtist: {
                type: Function,
                required: true
            }
        },
        emits: ['update:user-data'],
        methods: {
            bookArtist(artist) {
                this.toggleArtist(artist)

                this.$emit('update:user-data', {
                    ...this.userData,
                    selectedArtists: [...this.userData.selectedArtists]
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .results-container {
        @include flex-start;
        flex-direction: column;
        gap: 24px;

        .heading {
            @include flex-start;
            flex-direction: column;
            gap: 8px;

            .title {
                color: $white;
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
        }

        .results {
            @include flex-start;
            flex-direction: row;
            gap: 16px;
            flex-wrap: wrap;

            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: center;
            }
        }

        .subtitle {
            color: $darker-grey;
            @include base-font-16;
            font-weight: 400;
            line-height: 24px;
        }
    }
</style>
